<template>
  <svg id="Сгруппировать_4772" data-name="Сгруппировать 4772" xmlns="http://www.w3.org/2000/svg" width="22.657" height="22.657" viewBox="0 0 22.657 22.657">
    <path id="Контур_4055" data-name="Контур 4055" d="M181.432-586.3A11.329,11.329,0,0,0,170.1-574.971a11.329,11.329,0,0,0,11.329,11.329,11.328,11.328,0,0,0,11.329-11.329A11.328,11.328,0,0,0,181.432-586.3Zm4.181,7.556a1.623,1.623,0,0,1,1.623,1.623,1.624,1.624,0,0,1-1.623,1.623,1.623,1.623,0,0,1-1.623-1.623A1.623,1.623,0,0,1,185.613-578.744Zm-8.362,0a1.623,1.623,0,0,1,1.623,1.623,1.623,1.623,0,0,1-1.623,1.623,1.623,1.623,0,0,1-1.623-1.623A1.624,1.624,0,0,1,177.25-578.744Zm10.294,7.711a7.425,7.425,0,0,1-6.113,3.218,7.419,7.419,0,0,1-6.113-3.218.992.992,0,0,1,.255-1.38.991.991,0,0,1,1.38.255,5.436,5.436,0,0,0,4.478,2.358,5.442,5.442,0,0,0,4.479-2.358.993.993,0,0,1,1.38-.255A.994.994,0,0,1,187.544-571.033Z" transform="translate(-170.103 586.3)" fill="#e1cd9d"/>
  </svg>
</template>

<script>
  export default {
    name: 'IconSmile',
  }
</script>
